import { i18n } from '@/i18n';
import { type QueryError, isGQLErrorOfType } from '@/utils/errors';

export const getAuthErrorMessage = (error: QueryError): string => {
  if (isGQLErrorOfType(error, 'UserExists')) {
    return i18n.t('auth:errors.user_exists');
  }
  if (isGQLErrorOfType(error, 'MerValidationErrFailedValidation')) {
    return i18n.t('auth:errors.validation_failed');
  }
  if (isGQLErrorOfType(error, 'InvalidLogin')) {
    return i18n.t('auth:errors.wrong_password');
  }
  if (isGQLErrorOfType(error, 'VerificationCodeInvalid')) {
    return i18n.t('auth:errors.code_invalid');
  }
  if (isGQLErrorOfType(error, 'VerificationCodeExpired')) {
    return i18n.t('auth:errors.code_expired');
  }

  // The auth mutations carry the user's plaintext password in their variables,
  // and both the `ClientError` message and graphql-js coercion errors can echo
  // those variables back. Nothing error-derived is safe to render here, so every
  // unrecognised code falls through to fixed copy.
  return i18n.t('auth:errors.unknown_error');
};
